import { warn } from "@/lib/log";

/** Safe wrapper around localStorage (Safari private mode / disabled storage never throws). Only UI preferences live here. */
export const storage = {
  get(key, fallback = null) {
    try { return localStorage.getItem(key) ?? fallback; } catch { return fallback; }
  },
  set(key, value) {
    try { localStorage.setItem(key, value); } catch (err) { warn("storage.set failed:", err); }
  },
  getJSON(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
  },
  setJSON(key, value) {
    storage.set(key, JSON.stringify(value));
  },
  remove(key) {
    try { localStorage.removeItem(key); } catch { /* ignore */ }
  },
};
